/* The Backflow Depot · product page redesign behaviour.
   Plain JS. Reads window.BFD_PDP (written by sections/bfd-pdp.liquid) and drives the
   variant picker, sticky CTA, bottom sheet, quantity steppers, copy button and the
   quote counter. Cart adds go through the theme's <product-form>; quote adds go through
   assets/quote-request.js ([data-add-to-quote]). Quote-only products carry no price here. */
(function () {
  /* ---------- CTA buttons on recommendation cards ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-card-quote]');
    if (q) {
      document.dispatchEvent(new CustomEvent('quote:add', { detail: { variantId: q.dataset.variantId, title: q.dataset.title, sku: q.dataset.sku || null, image: q.dataset.image || null, handle: q.dataset.handle || null, quantity: 1 } }));
      return;
    }
    var c = e.target.closest('[data-card-cart]');
    if (!c || c.disabled) return;
    var routes = (window.theme && theme.routes) || {};
    c.disabled = true; c.classList.add('is-loading');
    fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(c.dataset.variantId), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        var bubble = document.getElementById('cart-icon-bubble');
        var p = bubble ? fetch('?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) { if (d['cart-icon-bubble']) bubble.innerHTML = d['cart-icon-bubble']; }).catch(function () {}) : Promise.resolve();
        return p.then(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.refresh) return drawer.refresh(true).then(function () { drawer.open(); });
          location.href = routes.cart || '/cart';
        });
      })
      .catch(function () { c.textContent = 'Try again'; })
      .then(function () { c.disabled = false; c.classList.remove('is-loading'); });
  });

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var P = window.BFD_PDP;
  var root = $('.bfd-pdp');
  if (!P || !root) return;
  /* description: clamp long text to 4 lines with a Read more toggle */
  document.addEventListener('click', function (e) { var t = e.target.closest('[data-fit-toggle]'); if (t) t.closest('.fit').classList.add('is-open'); });
  var teaser = $('[data-gw-teaser]', root);
  if (teaser) {
    var tries = 0, check = setInterval(function () {
      var gw = document.getElementById('goes-with'); tries++;
      var ready = gw && gw.querySelector('.goes-with__inner');
      if (ready) { clearInterval(check); return; }
      if (tries > 16) { clearInterval(check); teaser.hidden = true; }
    }, 500);
  }
  function setupDesc() {
    $$('[data-desc]', root).forEach(function (d) {
      var t = d.querySelector('.pdp-desc-text'), btn = d.querySelector('[data-desc-more]');
      d.classList.add('is-clamped');
      if (t.scrollHeight > t.clientHeight + 2) {
        btn.hidden = false;
        btn.addEventListener('click', function () { var c = d.classList.toggle('is-clamped'); btn.textContent = c ? 'Read more' : 'Show less'; });
      } else { d.classList.remove('is-clamped'); }
    });
  }
  if (document.readyState === 'complete') setupDesc(); else window.addEventListener('load', setupDesc);
  var form = $('form.js-product-form-main', root);
  var idInput = form && form.querySelector('[name="id"]');

  /* ---------- quote count: read from the quote drawer's storage ---------- */
  function quoteCount() {
    try {
      var items = JSON.parse(localStorage.getItem('bfd_quote_items_v1') || '[]');
      return (Array.isArray(items) ? items : []).reduce(function (n, it) { return n + (Number(it.quantity) || 1); }, 0);
    } catch (e) { return 0; }
  }
  function renderQuote() {
    var n = quoteCount();
    $$('[data-quote-line]', root).forEach(function (el) {
      el.hidden = n === 0;
      var t = el.querySelector('[data-quote-text]');
      if (t) t.textContent = n + (n === 1 ? ' item' : ' items') + ' in your quote';
    });
  }
  renderQuote();
  window.addEventListener('storage', renderQuote);
  document.addEventListener('quote:changed', renderQuote);
  document.addEventListener('click', function () { setTimeout(renderQuote, 60); });

  /* ---------- qty steppers (every stepper on the page stays in sync) ---------- */
  function setQty(v) { v = Math.max(1, Math.min(999, v | 0)); $$('[data-qty] input', root).forEach(function (i) { i.value = v; }); }
  $$('[data-qty]', root).forEach(function (q) {
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]'); if (!b) return;
      setQty(Number(q.querySelector('input').value) + Number(b.getAttribute('data-step')));
    });
    q.querySelector('input').addEventListener('change', function (e) { setQty(Number(e.target.value)); });
  });

  /* ---------- variants ---------- */
  var V = P.variants || [];
  var sel = V.length ? (V.filter(function (v) { return v.id === P.selected; })[0] || V[0]).options.slice() : null;
  function findVariant(opts) {
    return V.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
  }
  function stockOf(v) { return v.tracked ? v.stock : (v.available ? 999 : 0); }

  function renderVariant() {
    var v = sel ? findVariant(sel) : V[0];
    if (!v) return;
    var stock = stockOf(v), out = stock <= 0, low = !out && stock <= 3 && P.mode === 'buy';
    if (idInput) idInput.value = v.id;
    $$('[data-bind="variant"]', root).forEach(function (el) { el.textContent = v.options.join(' · '); });
    $$('[data-bind="sku"]', root).forEach(function (el) { el.textContent = v.sku || '—'; });
    $$('[data-copy]', root).forEach(function (el) { el.setAttribute('data-copy', v.sku || ''); });
    $$('.partno, .plate-id', root).forEach(function (el) { el.hidden = !v.sku; });
    if (P.mode === 'buy') $$('[data-bind="price"]', root).forEach(function (el) { el.textContent = v.price; });

    var detail = P.mode === 'quote'
      ? (out ? '' : ' <span class="detail">· We confirm on your estimate</span>')
      : (out ? ' <span class="detail">· We can order it</span>' : ' <span class="detail">· Ready to ship</span>');
    $$('[data-bind="stock"]', root).forEach(function (el) {
      if (P.mode === 'quote') { el.hidden = true; return; }
      el.hidden = false;
      el.className = 'stock ' + (out ? 'stock--out' : low ? 'stock--low' : 'stock--in');
      el.innerHTML = '<span class="dot"></span>' + (out ? 'Out of stock' : low ? 'Only ' + stock + ' left' : 'In stock') + detail;
    });
    $$('[data-bind="stock-short"]', root).forEach(function (el) {
      el.className = 'st-sub ' + (out ? 'warn' : 'ok');
      el.textContent = out ? 'Out of stock' : low ? 'Only ' + stock + ' left' : 'In stock';
    });

    // a buy-now item that is out of stock is never a dead end: the button becomes Request a quote
    if (P.mode === 'buy') {
      $$('[data-cta]', root).forEach(function (b) {
        if (out) {
          b.type = 'button'; b.removeAttribute('data-cart'); b.setAttribute('data-add-to-quote', '');
          b.textContent = 'Request a quote';
        } else {
          b.removeAttribute('data-add-to-quote'); b.setAttribute('data-cart', '');
          if (b.hasAttribute('data-main')) b.type = 'submit';
          b.textContent = 'Add to cart';
        }
      });
      $$('[data-oos-help]', root).forEach(function (el) { el.hidden = !out; });
    }

    // option states
    $$('[data-opt]', root).forEach(function (b) {
      var i = Number(b.getAttribute('data-opt')), val = b.getAttribute('data-value');
      var trial = sel.slice(); trial[i] = val;
      var tv = findVariant(trial), on = sel[i] === val;
      b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', on ? 'true' : 'false');
      b.disabled = !tv;
      // quote-only products show no stock state at all (owner rule, T-18): no
      // "In stock" / "Out of stock" text and no sold-out styling on the buttons
      var buy = P.mode === 'buy';
      b.classList.toggle('is-out', buy && !!tv && stockOf(tv) <= 0);
      b.classList.toggle('is-in', buy && !!tv && stockOf(tv) > 0);
      var s = b.querySelector('[data-opt-price]');
      if (s && tv && buy) s.textContent = tv.price;
      var st = b.querySelector('[data-opt-stock]');
      if (st && buy) st.textContent = !tv ? 'Not made' : stockOf(tv) <= 0 ? 'Out of stock' : 'In stock';
    });
    $$('[data-bind="opt-label"]', root).forEach(function (el) { el.textContent = sel[Number(el.getAttribute('data-i'))]; });

    // keep the URL on the selected variant (SEO canonical is unchanged)
    if (V.length > 1 && window.history && history.replaceState) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    // gallery: jump to the variant's own photo
    if (v.media) { var t = $('[data-media="' + v.media + '"]', root); if (t) t.click(); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-opt]'); if (!b || b.disabled || !sel || !root.contains(b)) return;
    var i = Number(b.getAttribute('data-opt'));
    sel[i] = b.getAttribute('data-value');
    if (!findVariant(sel)) {
      var alt = V.filter(function (v) { return v.options[i] === sel[i]; })[0];
      if (alt) sel = alt.options.slice();
    }
    renderVariant();
  });
  renderVariant();

  /* ---------- bottom sheet ---------- */
  var sheet = $('.sheet', root), sheetOpener = null;
  if (sheet) sheet.inert = true;
  function openSheet(opener) {
    document.body.classList.add('sheet-open', 'drawer-open');
    sheetOpener = opener || document.activeElement;
    if (sheet) { sheet.inert = false; sheet.setAttribute('aria-hidden', 'false'); var f = sheet.querySelector('.sheet-title'); if (f) { f.setAttribute('tabindex', '-1'); f.focus(); } }
  }
  function closeSheet() {
    var was = document.body.classList.contains('sheet-open');
    document.body.classList.remove('sheet-open', 'drawer-open');
    if (sheet) { sheet.setAttribute('aria-hidden', 'true'); sheet.inert = true; }
    if (was && sheetOpener && sheetOpener.focus) { try { sheetOpener.focus(); } catch (e) {} }
  }
  // keep Tab inside the open sheet
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Tab' || !sheet || !document.body.classList.contains('sheet-open')) return;
    var f = $$('button:not([disabled]), a[href], input, [tabindex="0"]', sheet).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && (document.activeElement === first || document.activeElement === sheet.querySelector('.sheet-title'))) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-sheet]'); if (o) { e.preventDefault(); openSheet(o); }
    if (e.target.closest('[data-close-sheet]')) { closeSheet(); }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeSheet(); });

  /* ---------- cart buttons outside the form (sticky bars, sheet) submit the main form ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cta][data-cart]'); if (!b || b.hasAttribute('data-main') || !form) return;
    e.preventDefault();
    var main = $('[data-cta][data-main]', form);
    if (form.requestSubmit && main) form.requestSubmit(main); else form.submit();
    closeSheet();
  });
  // quote adds close the sheet too; quote-request.js handles the add itself
  document.addEventListener('click', function (e) { if (e.target.closest('[data-add-to-quote]') && root.contains(e.target)) closeSheet(); });

  /* ---------- sticky CTA: shows whenever the main CTA is off screen ---------- */
  var main = $('[data-main-cta]', root), bars = $$('.sticky', root);
  bars.forEach(function (b) { b.inert = true; });
  if (main && bars.length && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var phone = window.matchMedia('(max-width: 989px)').matches;
      var gone = !es[0].isIntersecting && (phone || es[0].boundingClientRect.top < 0);
      bars.forEach(function (b) { b.setAttribute('data-state', gone ? 'visible' : 'hidden'); b.inert = !gone; });
      document.body.classList.toggle('sticky-on', gone);
      document.body.classList.toggle('cta-in-view', es[0].isIntersecting);
    }, { threshold: 0 }).observe(main);
  }

  /* ---------- copy part number ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b || !root.contains(b)) return;
    var txt = b.getAttribute('data-copy'), lbl = b.querySelector('.lbl');
    var done = function () { b.setAttribute('data-copied', ''); if (lbl) lbl.textContent = 'Copied'; setTimeout(function () { b.removeAttribute('data-copied'); if (lbl) lbl.textContent = 'Copy'; }, 1800); };
    try { navigator.clipboard.writeText(txt).then(done, done); } catch (err) { done(); }
  });

  /* ---------- gallery thumbs ---------- */
  var thumbs = $$('.thumb', root), slides = $$('.stage .slide', root);
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      slides.forEach(function (s, j) { s.hidden = j !== i; });
      var c = $('[data-slide-count] b', root); if (c) c.textContent = i + 1;
    });
  });
})();
